import { z } from "zod";

/** Pediatric growth measurement API contracts. */

const dateStr = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, "Expected YYYY-MM-DD");

export const growthMeasurementApiSchema = z.object({
	id: z.string().uuid(),
	clinic_id: z.string().uuid(),
	patient_id: z.string().uuid(),
	visit_id: z.string().uuid().nullable(),
	measured_at: dateStr,
	weight_kg: z.string().nullable(),
	height_cm: z.string().nullable(),
	head_circumference_cm: z.string().nullable(),
	notes: z.string().nullable(),
	recorded_by_member_id: z.string().uuid().nullable(),
	created_at: z.string().datetime(),
	updated_at: z.string().datetime(),
});
export type GrowthMeasurementApi = z.infer<typeof growthMeasurementApiSchema>;

export const createGrowthMeasurementInputSchema = z
	.object({
		patient_id: z.string().uuid(),
		visit_id: z.string().uuid().optional(),
		measured_at: dateStr,
		weight_kg: z.coerce.number().positive().max(150).nullable().optional(),
		height_cm: z.coerce.number().positive().max(220).nullable().optional(),
		head_circumference_cm: z.coerce
			.number()
			.positive()
			.max(70)
			.nullable()
			.optional(),
		notes: z.string().max(1000).optional(),
	})
	.refine(
		(v) =>
			v.weight_kg != null ||
			v.height_cm != null ||
			v.head_circumference_cm != null,
		{
			message:
				"At least one of weight / height / head circumference is required",
		},
	);
export type CreateGrowthMeasurementInput = z.infer<
	typeof createGrowthMeasurementInputSchema
>;
